import { call, put, takeLatest } from 'redux-saga/effects';
import { Map, List } from 'immutable';
import { Notification } from '@utils';
import {
  getProcessos as getProcessosSdk,
  getProcesso as getProcessoSdk,
  getProcessosByLote as getProcessosByLoteSdk,
} from '@sdk/Logs/Tempos';

//Action Types
export const Types = {
  GET_PROCESSOS: 'LOGS_TEMPOS/GET_PROCESSOS',
  GET_PROCESSOS_SUCCESS: 'LOGS_TEMPOS/GET_PROCESSOS_SUCCESS',
  GET_PROCESSOS_ERROR: 'LOGS_TEMPOS/GET_PROCESSOS_ERROR',

  GET_PROCESSO: 'LOGS_TEMPOS/GET_PROCESSO',
  GET_PROCESSO_SUCCESS: 'LOGS_TEMPOS/GET_PROCESSO_SUCCESS',
  GET_PROCESSO_ERROR: 'LOGS_TEMPOS/GET_PROCESSO_ERROR',

  GET_PROCESSOS_BY_LOTE: 'LOGS_TEMPOS/GET_PROCESSOS_BY_LOTE',
  GET_PROCESSOS_BY_LOTE_SUCCESS: 'LOGS_TEMPOS/GET_PROCESSOS_BY_LOTE_SUCCESS',
  GET_PROCESSOS_BY_LOTE_ERROR: 'LOGS_TEMPOS/GET_PROCESSOS_BY_LOTE_ERROR',

  RESET: 'LOGS_TEMPOS/RESET',
};

//Action Creators
export const getProcessos = ({ id, page = 1, startDate, endDate }) => ({ type: Types.GET_PROCESSOS, id, page, startDate, endDate });
export const getProcessosSuccess = (data) => ({ type: Types.GET_PROCESSOS_SUCCESS, data });
export const getProcessosError = (error) => ({ type: Types.GET_PROCESSOS_ERROR, error });

export const getProcesso = ({ id }) => ({ type: Types.GET_PROCESSO, id });
export const getProcessoSuccess = (data) => ({ type: Types.GET_PROCESSO_SUCCESS, data });
export const getProcessoError = (error) => ({ type: Types.GET_PROCESSO_ERROR, error });

export const getProcessosByLote = ({ lote }) => ({ type: Types.GET_PROCESSOS_BY_LOTE, lote });
export const getProcessosByLoteSuccess = (data) => ({ type: Types.GET_PROCESSOS_BY_LOTE_SUCCESS, data });
export const getProcessosByLoteError = (error) => ({ type: Types.GET_PROCESSOS_BY_LOTE_ERROR, error });

export const reset = () => ({ type: Types.RESET });

//saga

function* fetchGetProcessos(action) {
  try {
    const { id, page, startDate, endDate } = action;
    const processos = yield call(getProcessosSdk, { id, page, startDate, endDate });
    yield put(getProcessosSuccess(processos));
  } catch (err) {
    Notification.error(err.message);
    yield put(getProcessosError(err));
  }
}

function* fetchGetProcesso(action) {
  try {
    const { id } = action;
    const processo = yield call(getProcessoSdk, { id });
    yield put(getProcessoSuccess(processo));
  } catch (err) {
    Notification.error(err.message);
    yield put(getProcessoError(err));
  }
}

function* fetchGetProcessosByLote(action) {
  try {
    const { lote } = action;
    const processosByLote = yield call(getProcessosByLoteSdk, { lote });
    yield put(getProcessosByLoteSuccess(processosByLote));
  } catch (err) {
    Notification.error(err.message);
    yield put(getProcessosByLoteError(err));
  }
}

export const saga = [
  takeLatest(Types.GET_PROCESSOS, fetchGetProcessos),
  takeLatest(Types.GET_PROCESSO, fetchGetProcesso),
  takeLatest(Types.GET_PROCESSOS_BY_LOTE, fetchGetProcessosByLote),
];

// Reducer
const initialState = Map({
  processos: List(),
  processosByLote: List(),
  processo: {},
  xTotalPage: 0,
  xCurrentPage: 0,
  idProcesso: -1,

  loadingProcessos: false,
  successProcessos: false,
  errorProcessos: false,
  hasMoreProcessos: false,

  loadingProcesso: false,
  successProcesso: false,
  errorProcesso: false,

  loadingProcessosByLote: false,
  successProcessosByLote: false,
  errorProcessosByLote: false,
});

const handleGetProcessos = (state, action) => {
  return state.set('loadingProcessos', true).set('successProcessos', false).set('errorProcessos', false);
};

const handleGetProcessosSuccess = (state, action) => {
  const { data, xCurrentPage, xTotalPage } = action.data;

  let todosProcessos = [];
  let idProcesso = -1;

  if (xCurrentPage === 1) {
    todosProcessos = List(data);
    if (data.length > 0) {
      idProcesso = data[0].id;
    }
  } else {
    todosProcessos = List([...state.get('processos').toArray(), ...data]);
  }

  return state
    .set('processos', todosProcessos)
    .set('idProcesso', idProcesso)
    .set('xTotalPage', xTotalPage)
    .set('xCurrentPage', xCurrentPage)
    .set('hasMoreProcessos', xTotalPage !== xCurrentPage)
    .set('loadingProcessos', false)
    .set('successProcessos', true)
    .set('errorProcessos', false);
};

const handleGetProcessosError = (state, action) => {
  return state.set('loadingProcessos', false).set('successProcessos', false).set('errorProcessos', action.error);
};

const handleGetProcesso = (state, action) => {
  return state.set('loadingProcesso', true).set('successProcesso', false).set('errorProcesso', false);
};

const handleGetProcessoSuccess = (state, action) => {
  const { data } = action;
  return state.set('processo', data[0]).set('loadingProcesso', false).set('successProcesso', true).set('errorProcesso', false);
};

const handleGetProcessoError = (state, action) => {
  return state.set('loadingProcesso', false).set('successProcesso', false).set('errorProcesso', action.error);
};

const handleGetProcessosByLote = (state, action) => {
  return state.set('loadingProcessosByLote', true).set('successProcessosByLote', false).set('errorProcessosByLote', false);
};

const handleGetProcessosByLoteSuccess = (state, action) => {
  const { data } = action.data;

  const processos = data.map((row) => {
    return {
      id: row.id,
      idVisualizacao: row.data.details['id_informacao_visualizacao'],
      duration: row.data.durationInMilliseconds,
      startDate: row.data.startDate,
      start: row.data.startMilliseconds,
      endDate: row.data.endDate,
      end: row.data.endMilliseconds,
      userId: row.data.userId,
      userName: row.data.userName,
      customer: row.data.customer,
      url: row.data.url,
    };
  });

  return state
    .set('processosByLote', List(processos))
    .set('loadingProcessosByLote', false)
    .set('successProcessosByLote', true)
    .set('errorProcessosByLote', false);
};

const handleGetProcessosByLoteError = (state, action) => {
  return state.set('loadingProcessosByLote', false).set('successProcessosByLote', false).set('errorProcessosByLote', action.error);
};

const handleReset = (state, action) => {
  state = initialState;
  return state;
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.GET_PROCESSOS:
      return handleGetProcessos(state, action);
    case Types.GET_PROCESSOS_SUCCESS:
      return handleGetProcessosSuccess(state, action);
    case Types.GET_PROCESSOS_ERROR:
      return handleGetProcessosError(state, action);

    case Types.GET_PROCESSO:
      return handleGetProcesso(state, action);
    case Types.GET_PROCESSO_SUCCESS:
      return handleGetProcessoSuccess(state, action);
    case Types.GET_PROCESSO_ERROR:
      return handleGetProcessoError(state, action);

    case Types.GET_PROCESSOS_BY_LOTE:
      return handleGetProcessosByLote(state, action);
    case Types.GET_PROCESSOS_BY_LOTE_SUCCESS:
      return handleGetProcessosByLoteSuccess(state, action);
    case Types.GET_PROCESSOS_BY_LOTE_ERROR:
      return handleGetProcessosByLoteError(state, action);

    case Types.RESET:
      return handleReset(state, action);

    default:
      return state;
  }
}
